/*eslint-env webextensions*/
import {
  select,
  takeEvery
} from 'redux-saga/effects'

import states from '../lib/states'
import types from '../duck/types'

export function* watchUpdateStatus() {
  yield takeEvery(types.UPDATE_STATUS, updateElectronSizeAsync)
}

export function* watchUpdateSong() {
  yield takeEvery(types.UPDATE_SONG, updateElectronSizeAsync)
}

function* updateElectronSizeAsync() {
  // TODO: Check https://electronjs.org/docs/api/web-contents#contentssendchannel-arg1-arg2- & https://stackoverflow.com/questions/48284207/emit-custom-events-in-electron-app-from-main-to-renderer
  const { ipcRenderer } = window.require('electron')
  const state = yield select()

  switch (state.status) {
  case states.AUTOSYNC:
  case states.BUFFERING:
  case states.INITIALIZING:
  case states.INTERRUPTED:
  case states.PAUSED:
  case states.PLAYING:
    ipcRenderer.send('render-player')
    break

  case states.FAILED:
  case states.STOPPED:
    ipcRenderer.send('render-how-to-cast', 'connected')
    break

  case states.DISCONNECTED:
  case states.UNDEFINED:
  default:
    ipcRenderer.send('render-how-to-cast', 'disconnected')
    break
  }
}



// WEBPACK FOOTER //
// ./src/sagas/electronSaga.js